export function resolveLoanRoleBasePath(pathname = '') {
  if (pathname.startsWith('/whitelabel')) return '/whitelabel';
  if (pathname.startsWith('/employee')) return '/employee';
  if (pathname.startsWith('/agent')) return '/agent';
  return '/admin';
}

export function getLoanApplicationRoleConfig(roleBasePath = '/agent') {
  const basePath = roleBasePath || '/agent';

  return {
    roleBasePath: basePath,
    portalLabel:
      basePath === '/agent'
        ? 'Agent Portal'
        : basePath === '/employee'
          ? 'Employee Portal'
          : basePath === '/whitelabel'
            ? 'White Label Portal'
            : 'Admin Portal',
    dashboardPath: `${basePath}/dashboard`,
    loansPath: `${basePath}/loans`,
    productsPath: `${basePath}/apply/products`,
    productPaths: {
      home: `${basePath}/apply/home-loan`,
      business: `${basePath}/apply/business-loan`,
      personal: `${basePath}/apply/personal-loan`,
      car: `${basePath}/apply/car-loan`,
      education: `${basePath}/apply/education-loan`,
    },
  };
}
